import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateTaskGroup } from 'queries';

import { EstateTaskGroupLabel } from 'utils/estate';

interface Props {
  group: string;
  groupNumber: number;
  children?: React.ReactChild;
}

const useStyles = makeStyles((theme) => ({
  groupCollection: {
    display: 'block',
  },
  groupRow: {
    display: 'flex',
  },
  groupNumberBadgeWrapper: {
    paddingTop: 30,
    flex: '0 0 52px',
  },
  groupNumberBadge: {
    backgroundColor: '#2274A5',
    borderRadius: '12px',
    padding: '0px 8px 2px 8px',
    fontSize: '13px',
    color: '#ffffff',
  },
  groupLabel: {
    position: 'relative',
    padding: 0,
    margin: 0,
    flex: 29,
    paddingTop: 30,
    top: '-15px',
    verticalAlign: 'center',
  },
  columnLabel: {
    textAlign: 'center',
    flex: '0 0 160px',
    [theme.breakpoints.down('md')]: {
      flex: '0 0 100px',
    },
    background: '#F0FCFF',
    margin: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 10,
    paddingTop: 30,
  },
  fullScreenOnly: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));

export default function EstateTaskGroupRow({ group, children }: Props) {
  const classes = useStyles();
  const isFirmSpecificTask =
    EstateTaskGroupLabel[group as EstateTaskGroup] === 'Firm-Specific Tasks';

  return (
    <>
      {isFirmSpecificTask ? (
        <Typography className={classes.groupLabel}>
          <strong>{EstateTaskGroupLabel[group as EstateTaskGroup]}</strong>
        </Typography>
      ) : (
        <Typography className={classes.groupLabel}>
          {EstateTaskGroupLabel[group as EstateTaskGroup]}
        </Typography>
      )}

      {children}
    </>
  );
}
